export const DURATION_SHORT = 0.25;
export const DURATION_MEDIUM = 0.4;

export const DELAY_SHORT = 0.15;
